export const MOSAIC_TILE_COUNT = 3;
export const MAX_DISPLAY_IMAGE_WIDTH = 800;

